import { render, staticRenderFns } from "./favorite-tool.vue?vue&type=template&id=e3cf674c&scoped=true"
import script from "./favorite-tool.vue?vue&type=script&lang=js"
export * from "./favorite-tool.vue?vue&type=script&lang=js"
import style0 from "./favorite-tool.vue?vue&type=style&index=0&id=e3cf674c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3cf674c",
  null
  
)

export default component.exports